export const PHYSICAL_VACANCY_REQUEST = "PHYSICAL_VACANCY_REQUEST";
export const PHYSICAL_VACANCY_SUCCESS = "PHYSICAL_VACANCY_SUCCESS";

export const ECONOMIC_VACANCY_REQUEST = "ECONOMIC_VACANCY_REQUEST";
export const ECONOMIC_VACANCY_SUCCESS = "ECONOMIC_VACANCY_SUCCESS";

export const PUBLIC_POWER_REQUEST = "PUBLIC_POWER_REQUEST";
export const PUBLIC_POWER_SUCCESS = "PUBLIC_POWER_SUCCESS";

export const PUBLIC_AREA_POWER_COSTS_REQUEST = "PUBLIC_AREA_POWER_COSTS_REQUEST";
export const PUBLIC_AREA_POWER_COSTS_SUCCESS = "PUBLIC_AREA_POWER_COSTS_SUCCESS";
